<template lang="pug">
  router-view(v-loading="false")
</template>

<script>
export default {
  name: 'App',
};
</script>

<style></style>
